module.exports = __webpack_public_path__ + "static/grouppicture-39e7799307e62c9b92fefe12d8986da0.png";